import reduceOpacity from '../../common/utils/reduce-opacity';
import color from './color';

const INITIAL_OPACITY = 1;

const mediumEmphasis = (params) => {
  const { backgroundColor, surfaceColor, whiteColor, blackColor } = params;
  const targetColor =
    params.targetColor ||
    color({
      backgroundColor,
      surfaceColor,
      whiteColor,
      blackColor,
    });

  return reduceOpacity({
    targetColor,
    backgroundColor,
    surfaceColor,
    opacity: INITIAL_OPACITY,
    condition: (ratio) => ratio < 4.5,
    fallback: {
      rule: 'text.mediumEmphasis',
      params,
    },
  });
};

export default mediumEmphasis;
